<template>
  <PrimaryModal @clickBackground="modalStatePresenter.setIsShowSettingsModal(false)">
    <div
      class="problem-select-wrapper max-w-screen-lg box-border px-12 py-8 m-4 overflow-y-scroll"
      :class="{
        'custom-scrollbar': isLightMode(),
        'custom-scrollbar-dark': !isLightMode()
      }"
      style="user-select: none"
    >
      <h1 class="text-2xl">{{ $t('message.shortcutKey') }}</h1>
      <table class="w-full mt-2 table-auto text-lg rounded border-2 dark:border-dark-400 dark:bg-dark-500">
        <thead>
          <tr>
            <th class="border border-gray-300 dark:border-dark-400 bg-gray-200 dark:bg-dark-400">
              {{ $t('message.command') }}
            </th>
            <th class="border border-gray-300 dark:border-dark-400 bg-gray-200 dark:bg-dark-400">
              {{ $t('message.keyBind') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center select">
            <td class="border px-1 py-1 border-gray-300 dark:border-dark-400">
              {{ $t('message.run') }}
            </td>
            <td class="border px-1 py-1 w-9/12 border-gray-300 dark:border-dark-400">
              <div class="dropdown w-full relative px-2">
                <button
                  class="border pt-1 pl-2 pr-1 mt-1 items-center rounded focus:outline-none text-lg w-full border-gray-500 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text"
                  v-on:mouseover="nested.hide.value = false"
                >
                  <span class="mr-0 notranslate" style="float: left">
                    {{ nested.input[0].value }}
                  </span>
                  <svg
                    class="fill-current h-4 w-4"
                    style="float: right; margin-top: 4px"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </button>
                <ul v-show="!nested.hide.value" class="w-11/12 dropdown-menu absolute hidden shadow-xl z-10">
                  <li v-for="(item, index) in items" :key="index" :value="item">
                    <button
                      class="w-full py-1 px-2 min-w-full block whitespace-no-wrap text-left focus:outline-none text-lg border-r border-l"
                      :class="{
                        'list-round-first border-t': index == 0,
                        'list-round-last border-b': index == items.length - 1,
                        'bg-dark-200 text-dark-text hover:bg-dark-10': shortcutKey[1].value != item && !isLightMode(),
                        'bg-white text-gray-800 hover:bg-gray-400': isLightMode(),
                        'border-dark-200': !isLightMode(),
                        'bg-gray-400 hover:bg-gray-400 text-gray-800': shortcutKey[1].value == item && isLightMode(),
                        'bg-dark-10 text-dark-text': shortcutKey[1].value == item && !isLightMode()
                      }"
                      :disabled="shortcutKey[1].value == item"
                      v-on:click="onSelect(item, index, 0)"
                    >
                      {{ item }}
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr class="text-center select">
            <td class="border px-1 py-1 border-gray-300 dark:border-dark-400">
              {{ $t('message.submit') }}
            </td>
            <td class="border px-1 py-1 w-9/12 border-gray-300 dark:border-dark-400">
              <div class="dropdown w-full relative px-2">
                <button
                  class="border pt-1 pl-2 pr-1 mt-1 items-center rounded focus:outline-none text-lg w-full border-gray-500 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text"
                  v-on:mouseover="nested.hide.value = false"
                >
                  <span class="mr-0 notranslate" style="float: left">
                    {{ nested.input[1].value }}
                  </span>
                  <svg
                    class="fill-current h-4 w-4"
                    style="float: right; margin-top: 4px"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </button>
                <ul v-show="!nested.hide.value" class="w-11/12 dropdown-menu absolute hidden shadow-xl z-10">
                  <li v-for="(item, index) in items" :key="index" class="w-full" :value="item">
                    <button
                      class="w-full py-1 px-2 min-w-full block whitespace-no-wrap text-left focus:outline-none text-lg border-r border-l"
                      :class="{
                        'list-round-first border-t': index == 0,
                        'list-round-last border-b': index == items.length - 1,
                        'bg-dark-200 text-dark-text hover:bg-dark-10': shortcutKey[0].value != item && !isLightMode(),
                        'bg-white text-gray-800 hover:bg-gray-400': isLightMode(),
                        'border-dark-200': !isLightMode(),
                        'bg-gray-400 hover:bg-gray-400 text-gray-800': shortcutKey[0].value == item && isLightMode(),
                        'bg-dark-10 text-dark-text': shortcutKey[0].value == item && !isLightMode()
                      }"
                      :disabled="shortcutKey[0].value == item"
                      v-on:click="onSelect(item, index, 1)"
                    >
                      {{ item }}
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h1 class="text-2xl mt-10">{{ $t('message.darkmode') }}</h1>
      <div class="my-2 toggle-switch">
        <input id="toggle" v-model="isDarkMode" class="toggle-input" type="checkbox" @change="checkDarkMode()" />
        <label class="toggle-label" for="toggle" />
      </div>
      <!-- <h1 class="text-2xl mt-10">{{ $t('message.setJudgeNotification') }}</h1>
      <div class="my-2 toggle-switch">
        <input
          id="toggle"
          v-model="nested.isJudgeNotification.value"
          class="toggle-input"
          type="checkbox"
          @change="checkJudgeNotif()"
        />
        <label class="toggle-label" for="toggle" />
      </div> -->
      <h1 class="text-2xl mt-10">{{ $t('message.displayLanguage') }}</h1>
      <div class="my-2 flex items-start justify-start">
        <DropDown
          :itemList="displayLanguages"
          :selected="selectDisplayLanguage"
          :selectedIndex="nested.selectedDisplayLanguageIndex.value"
        />
      </div>
    </div>
  </PrimaryModal>
</template>

<script lang="ts">
import { computed, defineComponent, ref, Ref, watch } from 'vue'

import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import DropDown from '@/presentation/components/DropDown/DropDown.vue'
import PrimaryModal from '@/presentation/components/Modal/PrimaryModal.vue'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useModalStatePresenter } from '@/presentation/composables/modal/useModalStatePresenter'

export default defineComponent({
  components: { PrimaryModal, DropDown },
  props: {
    shortcutKey: {
      type: Array as () => Ref<string>[],
      requested: true
    }
  },
  setup(props, ctx) {
    const { displayLanguage, setDisplayLanguage } = useConfigStatePresenter()
    const modalStatePresenter = useModalStatePresenter()

    const displayLanguages = ['Japanese', 'English']
    const selectedDisplayLanguageIndex = ref(0)
    watch(
      () => displayLanguage.value,
      newValue => {
        selectedDisplayLanguageIndex.value = displayLanguages.findIndex(lang => lang == newValue)
      },
      { immediate: true }
    )

    const selectDisplayLanguage = (index: number, value: DisplayLanguageType) => {
      setDisplayLanguage(value)
    }

    const onSelect = (key: string, index: number, keyIndex: number) => {
      hide.value = true
      input[keyIndex].value = (props.shortcutKey as Ref<string>[])[keyIndex].value = key
      document.cookie = 'key' + keyIndex + '=' + key + '; max-age=2147483647'
    }

    const hide = ref(true)
    const input: Ref<string>[] = [ref(''), ref('')]
    input[0].value = (props.shortcutKey as Ref<string>[])[0].value
    input[1].value = (props.shortcutKey as Ref<string>[])[1].value
    const items = [
      'Alt+Shift+X',
      'Alt+X',
      'Ctrl+F11',
      'Ctrl+F10',
      'Shift+F10',
      'Shift+F9',
      'Alt+Shift+F10',
      'Alt+Shift+F9',
      'Ctrl+F5'
    ]

    const { setViewMode, reverseViewMode, isLightMode } = useConfigStatePresenter()

    if (isLightMode()) {
      setViewMode('LIGHT')
    } else {
      setViewMode('DARK')
    }

    const isDarkMode = computed(() => !isLightMode())
    const checkDarkMode = () => {
      reverseViewMode()
      if (isLightMode()) {
        document.cookie = 'darkmode=false; max-age=2147483647'
      } else {
        document.cookie = 'darkmode=true; max-age=2147483647'
      }
    }

    return {
      modalStatePresenter,
      onSelect,
      checkDarkMode,
      selectDisplayLanguage,
      isLightMode,
      items,
      displayLanguages,
      isDarkMode,
      nested: {
        input,
        hide,
        selectedDisplayLanguageIndex
      }
    }
  }
})
</script>

<style lang="postcss" scoped>
.problem-select-wrapper {
  width: 50vw;
  height: 70vh;
}
.select {
  user-select: none;
}
.click-effect:active {
  @apply bg-dark-10;
}
.dropdown:hover .dropdown-menu {
  display: block;
}
.note-list:last-child {
  border-bottom: 1px solid;
}
.toggle-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  opacity: 0;
  cursor: pointer;
}
.toggle-label {
  width: 72px;
  height: 32px;
  background: #ccc;
  position: relative;
  display: inline-block;
  border-radius: 46px;
  transition: 0.4s;
  box-sizing: border-box;
  &:after {
    content: '';
    position: absolute;
    width: 32px;
    height: 32px;
    border-radius: 100%;
    left: 0;
    top: 0;
    z-index: 2;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    transition: 0.4s;
  }
}
.toggle-input:checked {
  + .toggle-label {
    @apply bg-teal-700;
    &:after {
      left: 40px;
    }
  }
}
.toggle-switch {
  position: relative;
  width: 72px;
  height: 32px;
}
.list-round-first {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.list-round-last {
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
</style>
